import { useNavigate } from "react-router-dom"

import Style from "./style"
import check from "./asset/check.svg"
import checked from "./asset/checked.svg"

import MainHeader from "widget/MainHeader"
import Search from "widget/Search"
import Pagenation from "widget/Pagenation"

import useGetFranchiseList from "entity/franchise/useGetFranchiseManagerList"
import usePutFranchiseManagerApprove from "entity/franchise/usePostFranchiseManagerApprove"
import useDeleteFranchiseManagerApprove from "entity/franchise/useDeleteFranchiseManagerApprove"

import TStyle from "shared/style/tableStyle"
import timestampCalculator from "shared/lib/timestampCalculator"

const FranchiseManagerList = () => {
    const navigate = useNavigate()

    const [franchiseManagerList] = useGetFranchiseList()
    const [approveManager] = usePutFranchiseManagerApprove()
    const [unapproveManager] = useDeleteFranchiseManagerApprove()

    const sizeList = ["short", "long", "long", "expand", "long", "short", "long"]
    const tableHeadList = ["IDX", "이름", "연락처", "프렌차이즈", "대표 연락처", "승인", "가입 날짜"]

    return (
        <Style.Wrapper>
            <MainHeader>프렌차이즈 매니저 계정 목록</MainHeader>
            <Search placeholder="프렌차이즈 이름에 포함되는 글자로 검색" />

            <TStyle.TableDiv>
                <TStyle.TableRow $title>
                    {tableHeadList.map((elem, index) =>
                        <TStyle.Data $title $size={sizeList[index]}>{elem}</TStyle.Data>
                    )}
                </TStyle.TableRow>
                {franchiseManagerList?.data?.franchise_list?.map((elem, index) =>
                    <TStyle.TableRow $odd={index % 2 === 1} onClick={() => navigate(`/manager/franchise/${elem?.idx}/detail`)}>
                        <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
                        <TStyle.Data $size={sizeList[1]}>{elem?.name}</TStyle.Data>
                        <TStyle.Data $size={sizeList[2]}>{elem?.contact}</TStyle.Data>
                        <TStyle.Data $size={sizeList[3]}>{elem?.franchise_name}</TStyle.Data>
                        <TStyle.Data $size={sizeList[4]}>{elem?.franchise_contact}</TStyle.Data>
                        <TStyle.Data $size={sizeList[5]} onClick={(e) => elem?.is_approve ? unapproveManager(e, elem?.idx) : approveManager(e, elem?.idx)}>
                            <Style.Radio><img src={elem?.is_approve ? checked : check} /></Style.Radio>
                        </TStyle.Data>
                        <TStyle.Data $size={sizeList[6]}>{timestampCalculator(elem?.created_at)}</TStyle.Data>
                    </TStyle.TableRow>
                )}
            </TStyle.TableDiv>

            <Pagenation maxPage={franchiseManagerList?.data?.max_page} />
        </Style.Wrapper>
    )
}

export default FranchiseManagerList